import { api } from "boot/axios";

let cachePortData = null;

export default () => {
  //Portfolio Ids
  const portfolioIds = async () => {
    if (cachePortData) {
      return cachePortData;
    }
    const data = await api.get("/portfolio/v2/ids/");
    cachePortData = data;
    return data;
  };

  //Portfolio
  const brokerList = async () => {
    const data = await api.get("/portfolio/brokerlist/");
    return data;
  };

  //Get Protfolio Portfolio
  const portfolio = async () => {
    try {
      const data = await api.get("/portfolio/portfolio/");
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Get Portfolio Stock
  const portfoliostock = async () => {
    try {
      const data = await api.get("/portfolio/stock/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Get Portfolio Transaction
  const getPortfolioTransactions = async () => {
    try {
      const data = await api.get("/portfolio/transaction/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Post Portfolio Stock
  const postPortfolioTransaction = async (PortfolioTransaction) => {
    try {
      const data = await api.post(
        "/portfolio/transaction/",
        PortfolioTransaction
      );
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //update Portfolio Stock
  const updateportfoliostock = async (updateportfolio) => {
    try {
      const data = await api.patch("/portfolio/stock/", updateportfolio);

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  //delete Portfolio Stock
  const deleteportfoliostock = async (deleteportfolio) => {
    try {
      const data = await api.delete("/portfolio/stock/", {
        data: deleteportfolio,
      });

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Get Portfolio Demat
  const portfolioDemat = async () => {
    try {
      const data = await api.get("/portfolio/demat/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Post Portfolio Demat
  const postPortfolioDemat = async (PortfolioDemat) => {
    try {
      const data = await api.post("/portfolio/demat/", PortfolioDemat);
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Update Portfolio Demat
  const updatePortfolioDemat = async (PortfolioDemat) => {
    try {
      const data = await api.patch("/portfolio/demat/", PortfolioDemat);
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  //Delete Portfolio Demat
  const deletePortfolioDemat = async (PortfolioDemat) => {
    try {
      const data = await api.delete("/portfolio/demat/", {
        data: PortfolioDemat,
      });
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Get Portfolio Fixed Bank
  const portfolioFixedBank = async () => {
    try {
      const data = await api.get("/portfolio/fixed-bank/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Post Portfolio Fixed Bank
  const postPortfolioFixedBank = async (fixedBank) => {
    try {
      const data = await api.post("/portfolio/fixed-bank/", fixedBank);

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  //Update Portfolio Fixed Bank
  const updatePortfolioFixedBank = async (fixedBank) => {
    try {
      const data = await api.patch("/portfolio/fixed-bank/", fixedBank);
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  //Delete Portfolio Fixed Bank
  const deletePortfolioFixedBank = async (fixedBank) => {
    try {
      const data = await api.delete("/portfolio/fixed-bank/", {
        data: fixedBank,
      });

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  //Get Portfolio Saving Bank
  const portfolioSavingBank = async () => {
    try {
      const data = await api.get("/portfolio/saving/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Post Portfolio Saving Bank
  const postPortfolioSavingBank = async (SavingBank) => {
    try {
      const data = await api.post("/portfolio/saving/", SavingBank);

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  //Update Portfolio Saving Bank
  const updatePortfolioSavingBank = async (SavingBank) => {
    try {
      const data = await api.patch("/portfolio/saving/", SavingBank);

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  //Delete Portfolio Saving Bank
  const deletePortfolioSavingBank = async (SavingBank) => {
    try {
      const data = await api.delete("/portfolio/saving/", {
        data: SavingBank,
      });

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Get Portfolio Loan
  const portfolioLoan = async () => {
    try {
      const data = await api.get("/portfolio/loan/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Post Portfolio Loan
  const postPortfolioLoan = async (portfolioLoan) => {
    try {
      const data = await api.post("/portfolio/loan/", portfolioLoan);

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  //Update Portfolio Loan
  const updatePortfolioLoan = async (portfolioLoan) => {
    try {
      const data = await api.patch("/portfolio/loan/", portfolioLoan);

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  //Delete Portfolio Loan
  const deletePortfolioLoan = async (portfolioLoan) => {
    try {
      const data = await api.delete("/portfolio/loan/", {
        data: portfolioLoan,
      });

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Real Estate

  //Get Real Estate
  const realEstate = async () => {
    try {
      const data = await api.get("/portfolio/real-estate/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Post Real Estate
  const postrealEstate = async (realEstate) => {
    try {
      const data = await api.post("/portfolio/real-estate/", realEstate);

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Update Real Estate
  const updaterealEstate = async (realEstate) => {
    try {
      const data = await api.patch("/portfolio/real-estate/", realEstate);

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  //Delete Real Estate
  const deleterealEstate = async (realEstate) => {
    try {
      const data = await api.delete("/portfolio/real-estate/", {
        data: realEstate,
      });

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Commodity

  //Get Commodity
  const commodity = async () => {
    try {
      const data = await api.get("/portfolio/commodity/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Post Commodity
  const postcommodity = async (commodity) => {
    try {
      const data = await api.post("/portfolio/commodity/", commodity);

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  //Update Commodity
  const updatecommodity = async (commodity) => {
    try {
      const data = await api.patch("/portfolio/commodity/", commodity);

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  //Delete Commodity
  const deletecommodity = async (commodity) => {
    try {
      const data = await api.delete("/portfolio/commodity/", {
        data: commodity,
      });

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Bank List
  const allBankList = async () => {
    try {
      const data = await api.get("/portfolio/bank/");
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  const clearPortCache = () => {
    cachePortData = null;
  };

  return {
    portfolioIds,
    brokerList,
    allBankList,
    portfolio,
    portfoliostock,
    getPortfolioTransactions,
    postPortfolioTransaction,
    updateportfoliostock,
    deleteportfoliostock,

    portfolioDemat,
    postPortfolioDemat,
    updatePortfolioDemat,
    deletePortfolioDemat,

    portfolioFixedBank,
    postPortfolioFixedBank,
    updatePortfolioFixedBank,
    deletePortfolioFixedBank,

    portfolioSavingBank,
    postPortfolioSavingBank,
    updatePortfolioSavingBank,
    deletePortfolioSavingBank,

    portfolioLoan,
    postPortfolioLoan,
    updatePortfolioLoan,
    deletePortfolioLoan,

    commodity,
    postcommodity,
    updatecommodity,
    deletecommodity,

    realEstate,
    postrealEstate,
    updaterealEstate,
    deleterealEstate,
    clearPortCache,
  };
};
